import { render, staticRenderFns } from "./rms-objects-plans-tab.vue?vue&type=template&id=0cddde9d&scoped=true"
import script from "./rms-objects-plans-tab.vue?vue&type=script&lang=js"
export * from "./rms-objects-plans-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cddde9d",
  null
  
)

export default component.exports